import React, { useEffect, useState } from "react";
import { RouterProvider, createBrowserRouter, useLocation, useNavigate, useParams } from "react-router-dom";
import publicRoutes from "./public";
import userRoutes from "./user"; // Import user-specific routes
import { USER_CURRENT_PATH } from "../helpers/common";
import { useDispatch, useSelector } from "react-redux";
import { setToggleHide } from "../redux/slices/sessionSlice";

const ProtectRoutes = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  const currentUrl = location.pathname || "";

  useEffect(() => {

    const userData = localStorage.getItem("currentUser");
    if (!userData) {
      if (!currentUrl.includes(`${USER_CURRENT_PATH.DISCUSS_INVITE}/${id}`)) {
        localStorage.clear();
        localStorage.clear();
        navigate(USER_CURRENT_PATH.HOME);
      }
    }

    const visitedPages = JSON.parse(localStorage.getItem("visitedPages")) || [];
    if (visitedPages.length > 0) {
      if (!visitedPages?.[visitedPages?.length - 1].includes(currentUrl)) {
        visitedPages.push(currentUrl);
        localStorage.setItem("visitedPages", JSON.stringify(visitedPages));
      } else {
        visitedPages.pop();
        visitedPages.push(currentUrl);
        localStorage.setItem("visitedPages", JSON.stringify(visitedPages));
      }
    } else {
      visitedPages.push(currentUrl);
      localStorage.setItem("visitedPages", JSON.stringify(visitedPages));
    }
    //
    if (window.location.pathname === USER_CURRENT_PATH.ABOUT_US
      || window.location.pathname === USER_CURRENT_PATH.CONTACT_US
      || window.location.pathname === USER_CURRENT_PATH.LEGAL_STUFF
      || window.location.pathname === USER_CURRENT_PATH.CREDIT
    ) {
      dispatch(setToggleHide(false))
    } else {
      dispatch(setToggleHide(true))
    }


  }, [navigate, id, currentUrl]);

  return <>{children}</>;
};

const PublicRoutes = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  const currentUrl = location.pathname || "";

  useEffect(() => {
    if (window.location.pathname === USER_CURRENT_PATH.ABOUT_US
      || window.location.pathname === USER_CURRENT_PATH.CONTACT_US
      || window.location.pathname === USER_CURRENT_PATH.LEGAL_STUFF
      || window.location.pathname === USER_CURRENT_PATH.CREDIT
    ) {
      dispatch(setToggleHide(false))
    } else {
      dispatch(setToggleHide(true))
    }
  }, [navigate, id, currentUrl]);

  return <>{children}</>;
};


const Routes = () => {

  const publicRoutesWithCheck = publicRoutes.map((route) => ({ ...route, element: <PublicRoutes>{route.element}</PublicRoutes> }));
  const protectedUserRoutes = userRoutes.map((route) => ({ ...route, element: <ProtectRoutes>{route.element}</ProtectRoutes> }));

  const router = createBrowserRouter([...publicRoutesWithCheck, ...protectedUserRoutes]);

  return (
    <>
      <RouterProvider router={router}></RouterProvider>
    </>
  );
};

export default Routes;
